import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChipGroupComponent } from '@libs/shared/ui/chip/chip-group.component';
import { ChipComponent } from '@libs/shared/ui/chip/chip.component';
import { ComplaintDialogService } from '@libs/shared/ui/dialogs/complaint-dialog/complaint-dialog.service';
import { ComplaintDialogComponent } from './complaint-dialog.component';

@NgModule({
  declarations: [ComplaintDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatRippleModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ChipGroupComponent,
    ChipComponent,
  ],
  providers: [ComplaintDialogService],
})
export class ComplaintDialogModule {
  constructor(private _complaintDialogService: ComplaintDialogService) {}
}
